import React, { useContext, useState } from "react"
import clsx from "clsx"

import { useQueryResponseLoading } from "./response"
import { useQueryRequest } from "./request"
import { ComponentRequest } from "./componentLayout"

const KycPagination = () => {
    const isLoading = useQueryResponseLoading()
    const { updateState } = useQueryRequest()
    const { comRequest } = useContext(ComponentRequest)

    const [page, setPage] = useState(1)

    const updatePage = (newPage) => {
        if (newPage < 1) return

        setPage(newPage)

        updateState({
            ...comRequest,
            page: newPage,
            items_per_page: 10,
        })
    }

    return (
        <div className="d-flex justify-content-end">
            <ul className="pagination">

                {/* Previous */}
                <li
                    className={clsx("page-item", {
                        disabled: isLoading || page === 1,
                    })}
                >
                    <button
                        className="page-link"
                        onClick={() => updatePage(page - 1)}
                    >
                        Previous
                    </button>
                </li>

                {/* Current Page */}
                <li className="page-item active">
                    <span className="page-link">{page}</span>
                </li>

                {/* Next */}
                <li
                    className={clsx("page-item", {
                        disabled: isLoading,
                    })}
                >
                    <button
                        className="page-link"
                        onClick={() => updatePage(page + 1)}
                    >
                        Next
                    </button>
                </li>

            </ul>
        </div>
    )
}

export default KycPagination